import { render, staticRenderFns } from "./alert-icon.vue?vue&type=template&id=5b884fe4&scoped=true&"
import script from "./alert-icon.js?vue&type=script&lang=js&"
export * from "./alert-icon.js?vue&type=script&lang=js&"
import style0 from "./alert-icon.css?vue&type=style&index=0&id=5b884fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b884fe4",
  null
  
)

export default component.exports